import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as projectApi from '../../api/project-api';
import CategoryGallery from '../../components/category-gallery/index'
import Helmet from 'react-helmet';



import store from '../../../store';
import { propsRecievedProjectsInCategory } from '../../actions/project-actions';

import './categoryPage.css';


class CategoryPage extends Component {
  constructor(props) {
    super()
    this.props = props
    this.state = {
      currentProps: false
    }
  }

  componentDidMount() {
    let categorySlug = this.props.params.categorySlug
    projectApi.getProjectsInCategory(categorySlug)
  }

  componentWillReceiveProps(nextProps){
   if(this.props !== nextProps) {
    this.setState({currentProps:true})
   } 
  }

  render() {
    if (this.state.currentProps === true) {
       return (
        <div>
        <Helmet
          htmlAttributes={{lang: "en", amp: undefined}} 
          title={this.props.params.categorySlug.toUpperCase()}
          titleTemplate="KK OBI - %s"
          titleAttributes={{itemprop: "name", lang: "en"}}
          meta={[
            {name: "description", content: "KK OBI - Stylist"},
            {property: "og:title", content: "KK OBI - Stylist"},
            {property: "og:image", content: "http://s3-eu-west-1.amazonaws.com/iamdeaneyelid/wp-content/uploads/2016/11/22215224/573545-800w.jpg"}
          ]}/>
          <CategoryGallery projects={this.props.projectsData} catSlug={this.props.params.categorySlug}/>
          <div className="CategoryGallery--text-container">
            <p className="CategoryGallery--text">{this.props.params.categorySlug} : {this.props.galleryName}</p>
          </div>
        </div> 
        )
    } else {
      return(null)
    }
  } 
}  

const mapStateToProps = (store) => {
  return {
    projectsData: store.projectState.projectsInCategoryData,
    galleryName: store.projectState.hoveredGalleryName
  };
};

export default connect(mapStateToProps)(CategoryPage);


/** WEBPACK FOOTER **
 ** ./src/js/views/categoryPage/categoryPage.js
 **/